const PickerConst = {
    viewModes: ['date', 'month', 'year', 'time'],
    dateTimeISO: 'YYYY-MM-DD HH:mm:ss',
    dateTimeLocale: 'LLL',
    defaultLocale: 'en-us',
    shortISO: 'YYYY-MM-DD',
    shortLocale: 'L',
    yearISO: 'YYYY',
    yearMonthISO: 'YYYY-MM',
    DATE: 'DATE',
    MONTH: 'MONTH',
    YEAR: 'YEAR',
    TIME: 'TIME',
    HOUR: 'HOUR',
    MINUTE: 'MINUTE',
    SECOND: 'SECOND',
    day: 'day',
    date: 'date',
    month: 'month',
    year: 'year',
    time: 'time',
    transition: 'tab-transition',
    transitionReverse: 'tab-transition-reverse',
};

export default PickerConst;
